import { Box, Typography } from '@mui/material';
import imagenBackground from "../../assets/Membership/Companies/img1.png";

const brandEmpresas = () => {
  return (
    <Box sx={{
      backgroundColor: "rgb(255, 255, 255)",
      width: "100%",
      padding: "18px 20px",
    }}>

      <Box className="centeredContainer">
        <Typography variant="h3"
          sx={{ 
            fontSize: {xs: "20px", sm: "24px"},
            fontWeight: "400",
            lineHeight: "1.67",
            backgroundColor: "rgb(25, 91, 224)",
            color: "rgb(255, 255, 255)",
            padding: "4px 24px",
            borderRadius: "12px",
          }}>
            Red de empresas Salud365
        </Typography> 

        <Box sx={{
          width: "70%",
          maxWidth: "1200px",
        }}>
          <Box
            component="img"
            src={imagenBackground}
            alt="imagen Benefits"
            loading="lazy"
            sx={{
              objectFit: "contain",
              mt: "24px",
              width: "100%",
          }}/>
        </Box>
      </Box>

    </Box>
  );
};

export default brandEmpresas;
